export { DialogContent, DialogTitle, DialogButton } from "rmwc";

import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { Dialog as RmwcDialog } from "rmwc";
import type { DialogProps as RmwcDialogProps } from "rmwc";
import useIsMounted from "~/hooks/useIsMounted";

export type DialogProps = RmwcDialogProps &
  React.HTMLProps<any> & {
    portalize?: boolean;
  };

let portalContainer: Element | null | "unset" = "unset";

export const Dialog: React.FC<DialogProps> = ({ portalize, ...otherProps }) => {
  const { open } = otherProps;
  const [shouldRender, setShouldRender] = useState(open);
  const isMounted = useIsMounted();
  useEffect(() => {
    if (open) {
      setShouldRender(true);
    } else {
      setTimeout(() => isMounted() && setShouldRender(false), 500);
    }
  }, [open]);

  if (portalContainer === "unset") {
    portalContainer = document.querySelector("#portal-container");
  }

  if (portalContainer === null || !portalize) {
    return <RmwcDialog {...otherProps} />;
  }

  if (!shouldRender) {
    return null;
  }

  return ReactDOM.createPortal(<RmwcDialog {...otherProps} />, portalContainer);
};
